import type { FC, ReactNode } from 'react'

import { Hammer, Telescope, Eye } from 'lucide-react'
import { cn } from '@/lib/utils'

import { statusLabels } from '@/constants/content'

interface StatusLabelProps {
    status: 'inDevelopment' | 'futureVision' | 'concept'
    className?: string
}

const styles = {
    inDevelopment: 'border-orange/50 bg-orange/10 text-orange',
    futureVision: 'border-cool-grey-light/40 bg-soft-white/5 text-cool-grey-light',
    concept: 'border-soft-white/20 bg-navy-950/60 text-soft-white/80'
}

const icons = {
    inDevelopment: Hammer,
    futureVision: Telescope,
    concept: Eye
}

// Honest status label. Text and icon carry the meaning, never colour alone.
export const StatusLabel: FC<StatusLabelProps> = ({ status, className }): ReactNode => {
    const Icon = icons[status]

    return (
        <span
            className={cn(
                'inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-[0.7rem] font-semibold tracking-[0.12em] whitespace-nowrap',
                styles[status],
                className
            )}
        >
            <Icon className='size-3.5' aria-hidden />
            {statusLabels[status]}
        </span>
    )
}
